import { createTheme } from "@mui/material/styles";

const ANKO = "'AnkoModerat', Helvetica, Arial, sans-serif";
const ANKO_BOLD = ANKO;
const ANKO_LIGHT = ANKO;

const MAGENTA = "#b7127e";
const DARK_BLUE = "#253746";
const GREEN = "#6bbf3f";

const theme = createTheme({
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 },
  },

  palette: {
    primary: { main: MAGENTA, contrastText: "#ffffff" },
    secondary: { main: GREEN, contrastText: "#ffffff" },
    text: { primary: "#333333", secondary: DARK_BLUE },
    background: { default: "#ffffff", paper: "#ffffff" },
    common: { black: "#14191f", white: "#ffffff" },
    grey: { 600: "#4a4a4a" },
  },

  typography: {
    fontFamily: ANKO,

    h1: {
      fontFamily: ANKO_BOLD,
      fontWeight: 700,
      fontSize: "65px",
      lineHeight: 1.3,
      color: "#ffffff",
      "@media (max-width:900px)": { fontSize: "40px" },
      "@media (max-width:600px)": { fontSize: "28px" },
    },

    h2: {
      fontFamily: ANKO,
      fontSize: "60px",
      color: MAGENTA,
      letterSpacing: "1px",
      fontWeight: 400,
      "@media (max-width:900px)": { fontSize: "40px" },
      "@media (max-width:600px)": { fontSize: "32px" },
    },

    h3: {
      fontFamily: ANKO_BOLD,
      fontSize: "38px",
      letterSpacing: "1px",
      fontWeight: 800,
      lineHeight: 1.2,
      "@media (max-width:900px)": { fontSize: "28px" },
      "@media (max-width:600px)": { fontSize: "22px" },
    },

    h4: {
      fontFamily: ANKO_BOLD,
      fontSize: "28px",
      fontWeight: 700,
      lineHeight: 1.3,
      "@media (max-width:900px)": { fontSize: "22px" },
      "@media (max-width:600px)": { fontSize: "20px" },
    },

    h5: {
      fontFamily: ANKO_BOLD,
      fontSize: "22px",
      fontWeight: 700,
    },

    h6: {
      fontFamily: ANKO_BOLD,
      fontSize: "18px",
      fontWeight: 700,
    },

    body1: {
      fontFamily: ANKO_LIGHT,
      fontSize: "18px",
      fontWeight: 300,
      lineHeight: 1.8,
      "@media (max-width:600px)": { fontSize: "16px" },
    },

    body2: {
      fontFamily: ANKO_LIGHT,
      fontSize: "16px",
      fontWeight: 300,
      lineHeight: 1.6,
      "@media (max-width:600px)": { fontSize: "14px" },
    },

    subtitle1: {
      fontFamily: ANKO,
      fontSize: "24px",
      fontWeight: 300,
      lineHeight: 1.1,
      "@media (max-width:600px)": { fontSize: "18px" },
    },

    subtitle2: {
      fontFamily: ANKO_LIGHT,
      fontSize: "16px",
      fontWeight: 300,
      lineHeight: 1.6,
    },

    caption: {
      fontFamily: ANKO,
      fontSize: "14px",
    },

    button: {
      fontFamily: ANKO,
      textTransform: "none" as const,
    },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "24px",
          textTransform: "none" as const,
          fontFamily: ANKO,
          fontSize: "14px",
          fontWeight: 500,
          padding: "10px 24px",
        },
        outlined: {
          borderWidth: "2px",
          "&:hover": { borderWidth: "2px" },
        },
      },
    },

    MuiTypography: {
      defaultProps: {
        variantMapping: { subtitle1: "p", subtitle2: "p" },
      },
    },
  },
});

export default theme;
